const salesData = [
    {
        id: 1,
        name: 'Engagement Model',
        description:'Support sales teams with frameworks that leverage behavioural science and foster value added engagement.',
        img: require('../images/howWeCanHelp/sales/engagementModel.jpg')
    },
    {
        id: 2,
        name: 'In-call Excellence',
        description:"Our award winning in-call excellence programs are designed to enhance skills, enabling more valuable customer interactions and driving higher levels of engagement and outcomes.",
        img: require('../images/howWeCanHelp/sales/incallExcellence.jpg')
    },
    {
        id: 3,
        name: 'Coaching',
        description:'Strategies and tools which support individuals to not only manage stress but to thrive and adapt in the face of it, creating growth opportunities that reach beyond the work environment. ',
        img: require('../images/howWeCanHelp/sales/inFieldCoaching.jpg')
    },
    {
        id: 4,
        name: 'Resilience',
        description:'Teach strategies and provide tools to not only manage stress but to thrive and adapt in the face of it, creating growth opportunities that reach beyond the work environment.',
        img: require('../images/howWeCanHelp/medical/resilience.png')
    },
    {
        id: 5,
        name: 'Account Management',
        description:'Equip teams to manage complex client relationships effectively, meeting client needs through cross-matrix collaboration and relationship building. ',
        img: require('../images/howWeCanHelp/sales/accountManagement.jpg')
    },
    {
        id: 6,
        name: 'Digital Assests',
        description:'Healthcare InterAction offers digital solutions that support the implementation of skills and support learning in the flow of work. Choose from a core library to custom designed assets.',
        img: require('../images/howWeCanHelp/sales/digitalAssets.jpg')
    },
    {
        id: 7,
        name: 'Engagement Excellence Event',
        description:'Award-winning events that foster team learning, while delivering insights to pinpoint optimal in-call execution and drive performance improvements.',
        img: require('../images/howWeCanHelp/marketing/e3.jpg')
    },
    {
        id: 8,
        name: 'The Congress Advantage',
        description:'Support your people to succeed and maximise your significant investment in congress with our modular programme to develop the skills, mindset and approaches needed.',
        img: require('../images/howWeCanHelp/sales/congress.jpg')
    },
    {
        id: 9,
        name: 'Live Link',
        description:'Live learning sessions that share in-call excellence strategies to improve performance via collaboration and best practice exchanges. ',
        img: require('../images/howWeCanHelp/sales/liveLink.jpg')
    }
]

const medicalData = [
    {
        id: 1,
        name: 'Scientific Engagement Model',
        description:'Support medical teams with frameworks fostering dynamic data discussions using behavioural science principles for better customer engagement.',
        img: require('../images/howWeCanHelp/medical/scientificEngagementModel.jpg')
    },
    {
        id: 4,
        name: 'Coaching',
        description:'With a focus on actionable strategies and measurable outcomes, our coaching is designed to help achieve peak performance, overcome challenges, and consistently exceed goals.',
        img: require('../images/howWeCanHelp/sales/inFieldCoaching.jpg')
    },
    {
        id: 6,
        name: 'Scientific Narratives',
        description:"Use proven methodologies to guide medical teams in presenting essential data, driving paradigm shifts in treatment objectives.",
        img: require('../images/howWeCanHelp/medical/scientificNarrative.jpg')
    },
{
        id: 7,
        name: 'Demonstrate Value',
        description:"Our 3-step approach helps Medical Affairs showcase value by leveraging evidence and cross-functional support, aligned with stakeholder agreements.",
        img: require('../images/howWeCanHelp/medical/demonstrateValue.jpg')
    },
    {
        id: 8,
        name: 'Insight into Action',
        description:"Craft actionable strategies from insights, whilst enabling impactful stakeholder discussions.",
        img: require('../images/howWeCanHelp/medical/insightIntoAction.jpg')
    },
    {
        id: 9,
        name: 'Cross-functional Teamwork',
        description:"Enhance collaboration by strengthening essential team skills, enabling smooth and productive cross-functional cooperation.",
        img: require('../images/howWeCanHelp/marketingBroad.jpg')
    }
]

const marketingData = [
    {
        id: 1,
        name: 'Commitment Continuum\u00AE',
        description:'Define customer commitment behaviours for focused objective setting, ensuring consistent, impactful, and valuable customer interactions.',
        img: require('../images/howWeCanHelp/marketing/commitmentContinuum.jpg')
    },
    {
        id: 2,
        name: 'Strategic Planning',
        description:"Help teams link actions to strategies through immersive sessions that foster innovative thinking.",
        img: require('../images/howWeCanHelp/marketing/stratPlanning.png')
    },
    {
        id: 4,
        name: 'Systems Thinking',
        description:'Healthcare systems are complex. Maximise collaboration opportunities with both non-clinical and clinical stakeholders and build success pathways that lead to better patient outcomes.',
        img: require('../images/howWeCanHelp/marketing/systemsThinking.jpg')
    },
    {
        id: 5,
        name: 'Launch Excellence',
        description:'Prepare teams to manage every product launch aspect effectively and efficiently, maximising market impact with precise, comprehensive strategic execution.',
        img: require('../images/howWeCanHelp/marketing/launchExcellence.jpg')
    },
    {
        id: 6,
        name: 'Business Planning',
        description:'Empower teams with bespoke plans for cross-functional accountability, balancing strategic and in-field goals to drive agile execution.',
        img: require('../images/howWeCanHelp/medical/businessPlanning.jpg')
    }
]

const leadershipData = [
    {
        id: 1,
        name: 'Coaching',
        description:"Focus on results-driven coaching techniques, empowering leaders to boost team performance through measurable, actionable coaching strategies.",
        img: require('../images/howWeCanHelp/leadership/coaching.jpg')
    },
    {
        id: 2,
        name: 'Develop and Communicate Vision',
        description:"Create and communicate clear, actionable vision plans to align teams, confidently address challenges and forge a path forward.",
        img: require('../images/howWeCanHelp/leadership/developCommunicateVision.jpg')
    },
    {
        id: 3,
        name: 'Empathetic Leadership',
        description:"Programmes to enhance compassionate leadership, fostering collaboration, trust, and effective team dynamics in any environment.",
        img: require('../images/howWeCanHelp/leadership/empatheticLeadership.jpg')
    },
    {
        id: 4,
        name: 'Leadership Models',
        description:"Interactive courses develop practical leadership skills, enabling participants to effectively address everyday business challenges.",
        img: require('../images/howWeCanHelp/leadership/leadershipModels.jpg')
    },
    {
        id: 5,
        name: 'Leading in a Remote World',
        description:'Equip leaders to adapt fundamental leadership principles for remote teams, ensuring efficient, long-distance collaboration.',
        img: require('../images/howWeCanHelp/leadership/leadingRemoteWorld.jpg')
    }
]

export default salesData;
export { marketingData, medicalData, leadershipData };